import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/creditor-users.js';
import q from '../query.js';
export const creditorUsersEntity = 'creditor-users';
const creditorUsersKey = (creditorId) => `creditor-users-${creditorId}`;
export const useCreditorUsers = (creditorId) => q.query(creditorUsersKey(creditorId), () => api.getByCreditorId(creditorId), keys.read.collection(creditorUsersEntity), { enabled: creditorId != null });
//# sourceMappingURL=index.js.map